import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Loading from '../Loading'

export default class LoadingButton extends Component {
  static propTypes = {
    ui: PropTypes.object,
    onClick: PropTypes.func
  }

  static defaultProps = {
    ui: {}
  }

  state = {
    ui: null
  }

  handleClick = async (e) => {
    const {onClick} = this.props
    if (!onClick) return

    this.setState({ui: {loading: true, status: null}})
    try {
      await onClick(e)
      if (!this.mounted) return
      this.setState({ui: {loading: false, status: 'ok'}})
    } catch (err) {
      if (!this.mounted) return
      this.setState({ui: {loading: false, status: 'fail'}})
    }
  }

  getState () {
    const ui = this.props.ui || this.state.ui
    const {loading, status} = ui
    return {loading, status}
  }

  componentDidMount () {
    this.mounted = true
  }

  componentWillUnmount () {
    this.mounted = false
  }

  renderState ({loading, status}) {
    if (loading && !status) {
      return <Loading />
    } else if (status === 'ok') {
      return <i className='success ion-checkmark' />
    } else if (status === 'fail') {
      return <i className='failure ion-close' />
    }

    return null
  }

  render () {
    const {className, ...props} = this.props
    const classes = cn(className, 'btn', 'loading-btn')
    const state = this.getState()
    props.disabled = state.loading

    return <button {...props} onClick={this.handleClick} className={classes}>
      {this.props.children}
      {this.renderState(state)}
    </button>
  }
}



// WEBPACK FOOTER //
// ./app/components/ui/LoadingButton.js